import React from 'react';

import SummaryCards from './dashboard/SummaryCards';
import Calendar from './dashboard/Calendar';
import Tools from './Tools';

const Dashboard = ({ commitments }) => {
  return (
    <div>

      <SummaryCards />

      <div className="row g-2 mt-1">
        <div className="col-9 col-xl-9">
          <Calendar commitments={commitments} />
        </div>

        <div className="col-3 col-xl-3 h-100 rounded-1">
          <Tools />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;